import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MinisiteView from './MinisiteView';
import { MINISITE_OCCASIONS, MINISITE_HUB_PATH } from '../utils/minisiteOccasions';

// Exemple de faire-part animé (mariage) dans un cadre de téléphone, même présentation que la démo de
// carte à gratter (DemoScratchCardPage.js) : cible du bandeau DemoBanner.js. 100 % statique, sans
// base de données ; le formulaire de réponse est affiché mais n'envoie rien (mode embarqué).
const DEMO = { occasion: 'mariage', ...MINISITE_OCCASIONS.mariage.demo, ...MINISITE_OCCASIONS.mariage.hub.demo };

const DemoMinisitePage = () => {
  const [replayKey, setReplayKey] = useState(0);

  return (
    <>
      <Helmet>
        <title>Exemple de faire-part animé | Joli Ptit Mot</title>
        <meta
          name="description"
          content="Découvrez un exemple de faire-part animé : prénoms animés, date, lieu avec plan, programme, compte à rebours et réponses des invités en ligne."
        />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Box sx={{ maxWidth: 480, margin: '0 auto', textAlign: 'center', py: { xs: 3, md: 5 } }}>
        <Typography
          variant="h4"
          sx={{ mb: 1, color: '#c48f8b', fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600 }}
        >
          Essayez pour voir !
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#7a6060' }}>
          Faites défiler l'écran ci-dessous pour découvrir ce que vos invités recevront : vos prénoms,
          la date, le programme, le plan d'accès et leur réponse en ligne.
        </Typography>

        <div className="ms-phone" style={{ width: 340, height: 700 }}>
          <MinisiteView key={replayKey} embedded params={DEMO} />
        </div>
        <Button size="small" sx={{ mt: 1 }} onClick={() => setReplayKey((k) => k + 1)}>
          Rejouer l'animation
        </Button>

        <Box>
          <Button
            component={Link}
            to={MINISITE_HUB_PATH}
            variant="contained"
            color="secondary"
            sx={{ mt: 3, borderRadius: 6, px: 4, py: 1.2, fontWeight: 700 }}
          >
            Créer le mien
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default DemoMinisitePage;
